module.exports = __webpack_public_path__ + "img/4f560e6.svg";